export function ManifestoSection({ copy }) {
  return (
    <section className="section manifesto-section" id="approach" data-reveal data-testid="manifesto-chapters-section">
      <div className="page-width">
        <div className="section-intro section-intro--split manifesto-intro"><div><p className="eyebrow">{copy.manifesto.eyebrow}</p><h2>{copy.manifesto.title}</h2></div><p>{copy.manifesto.intro}</p></div>
        <div className="manifesto-list">{copy.chapters.map((chapter) => <article className="manifesto-chapter" key={chapter.number} data-testid={`manifesto-chapter-${chapter.number}`}><span className="chapter-number">{chapter.number}</span><h3>{chapter.title}</h3><p>{chapter.body}</p><span className="chapter-mark">↗</span></article>)}</div>
      </div>
    </section>
  );
}
